import { useState, useEffect } from "react"
import { func, shape, string } from "prop-types"

const EventNameStep = ({
  event = {},
  setEvent = () => {},
  setNextButtonDisabled = () => {},
  signupPurpose = "specific"
}) => {
  const [name, setName] = useState(event.name)

  useEffect(() => {
    event.name = name
    setEvent(event)
    setNextButtonDisabled(!(name && name.trim().length > 0))
  }, [name, event, setEvent, setNextButtonDisabled])

  return (
    <div>
      <label htmlFor="new_event_name" className="h2 mb-3 fw-n">
        {signupPurpose == "ongoing" ? (
          <div>What’s the name of your program or opportunity?</div>
        ) : (
          <div>What’s the name of your event?</div>
        )}
      </label>
      <input
        defaultValue={event.name}
        name="event_name"
        type="text"
        placeholder="Name"
        className="big-input"
        autoComplete="off"
        id="new_event_name"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={true}
        maxLength={255}
        onChange={e => {
          setName(e.target.value)
        }}
      />
      <p className="font-size-4 info-alert alert mt-2 mb-0">
        After you save this signup, it will be hidden on Church Center so you can finish setting it
        up — and add additional details, like an image and description — before publishing it to
        your congregation.
      </p>
    </div>
  )
}

EventNameStep.propTypes = {
  setEvent: func,
  setNextButtonDisabled: func,
  signupPurpose: string,
  event: shape({})
}

export default EventNameStep
